import { useNavigate } from "react-router-dom";
//Icons
import { GrFormNextLink } from "react-icons/gr";
import { FaFacebookSquare, FaInstagram, FaYoutube } from 'react-icons/fa';
import { FaShop } from 'react-icons/fa6';
//Styles
import '../styles/views/quickView.css';

const externalLinks = require("../data/externalLinks.json");

function QuickView() {
    const navigate = useNavigate();

    return(
        <>
        
        <main className='main-quickView'>
            <section className="menu-container-quickView">
                <div className="menu-header-quickView">
                                <img src="images/logos/BSitesLogo00.webp" alt="Logo" />
                                <h1>B-Sites</h1>
                            </div>

                            <div className="menu-body-quickView">
                                <div className="opt-menu-quickView" onClick={() => navigate('/')}>
                                    <p>Sitio Web</p>
                                    <GrFormNextLink />
                                </div>
                                <div className="opt-menu-quickView" onClick={() => window.open(externalLinks.whatsapp)}>
                                    <p>Contacto</p>
                                    <GrFormNextLink />
                                </div>
                            </div>

                            <div className="menu-footer-quickView">
                                <a href='#facebook' onClick={() => window.open(externalLinks.facebbook)}>
                                <FaFacebookSquare size={28} className='facebook-icon'/>                        
                                </a>
                                <a href='#GoogleBusiness' onClick={() => window.open(externalLinks.googleBusiness)}>
                                <FaShop size={28} className='google-icon'/>                        
                                </a>
                                <a href='#Youtube' onClick={() => window.open(externalLinks.youtube)}>
                                <FaYoutube size={30} className='youtube-icon'/>                        
                                </a>
                                <a href='#instagram' onClick={() => window.open(externalLinks.instagram)}>
                                    <FaInstagram size={28} className='instagram-icon'/>                        
                                </a>
                                <p>Visítenos</p>
                            </div>
            </section>
            
        </main>

        </>
    );
}

export default QuickView;